import Vue from 'vue'
import mouse from '@/services/mouse.service'

const resource = '/api/accounts'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.dialog) this.$mouseAccount = options.mouseAccount
    else if (options.parent && options.parent.$mouseAccount)
      this.$mouseAccount = options.parent.$mouseAccount
  },
})

export default {
  /**
   * アカウント取得
   */
  async get(loginId) {
    try {
      const response = await mouse.get(`${resource}/${loginId}`)
      return response.data
    } catch (error) {
      if (error.response.status === 404) {
        return undefined
      } else {
        throw error
      }
    }
  },
  /**
   * アカウント登録
   */
  async add(props) {
    try {
      await mouse.post(`${resource}`, props)
    } catch (e) {
      // アクシデントではないエラーとして、ID重複はあり得る。
      if (e.response.status === 400) {
        return e.response.data
      }

      throw new Error(e)
    }
  },
  /**
   * アカウント削除
   */
  async delete(loginId) {
    await mouse.delete(`/${resource}/${loginId}`)
  },
}
